import { gql } from '@apollo/client';

export const createFeedbackQuery = gql`
  mutation createFeedback($input: InputCreateFeedback!) {
    createFeedback(input: $input)
  }
`;
